module.exports = __webpack_public_path__ + "img/MapSize.ae0ae086.webp";